import React from "react";
import { HERO } from "../data/content";
import RainbowText from "./RainbowText";

export default function Hero() {
  return (
    <section className="hero band cream" data-screen-label="01 Hero">
      <div className="band-bg" />
      <div className="scatter" />
      <div className="tear-bottom tear-cream-bottom" />

      <div className="float f1 balloon b-coral" />
      <div className="float f2 balloon b-sage" />
      <div className="float f3 balloon b-mustard" />
      <div className="float f4 balloon b-cream" />
      <div className="float f5 balloon b-coral" />
      <div className="float f6 balloon b-sage" />

      <div className="hero-inner">
        <div className="eyebrow">{HERO.eyebrow}</div>
        <h1 className="h-title">
          <RainbowText text={HERO.titleTop} className="h-title-top" />
          <RainbowText text={HERO.titleItal} className="h-title-ital" />
        </h1>
        <div className="h-welcome">
          <p className="h-welcome-heading">
            <span className="h-welcome-greet">Bienvenidos a</span>{" "}
            <RainbowText text={HERO.welcomeName} className="wordmark" />
          </p>
          <p className="h-welcome-lead">{HERO.lead}</p>
          <p className="h-welcome-para h-welcome-para-0">
            {HERO.para0Before}
            <RainbowText text="Loremi G" className="wordmark" />
            {HERO.para0After}
          </p>
          {HERO.paras.map((p, i) => (
            <p
              className={`h-welcome-para h-welcome-para-${i + 1}`}
              key={i}
              dangerouslySetInnerHTML={{ __html: p }}
            />
          ))}
        </div>
        <div className="h-tag">{HERO.tag}</div>

        <div className="cta-row">
          <a className="btn" href="#calendario">
            Apartar mi fecha
          </a>
          <a className="btn sage" href="#galeria">
            Ver galería
          </a>
          <button type="button" className="btn ghost" disabled aria-disabled="true" title="Próximamente">
            WhatsApp
          </button>
        </div>

        <div className="tickets">
          {HERO.tickets.map((t, i) => (
            <div className="ticket" key={i}>
              <b>{t.n}</b> {t.t}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
